import React from "react";
import { connect } from "react-redux";
import ReactDOMServer from "react-dom/server";
import L from "leaflet";
import { Popup } from "react-leaflet";
import { Card } from "tabler-react";
import ContentEditable from "react-contenteditable";
import Parser from "html-react-parser";
import "./style.css";
import { helper } from "../../../../../utils/helpers/helper";

const prefix = "leaflet-popup-button";

class EditablePopup extends React.Component {
  constructor(props) {
    super(props);

    const sourceTypes = [
      "Layer",
      "Circle",
      "CircleMarker",
      "Marker",
      "Polyline",
      "Polygon",
      "ImageOverlay",
      "VideoOverlay",
      "SVGOverlay",
      "Rectangle",
      "LayerGroup",
      "FeatureGroup",
      "GeoJSON",
    ];

    sourceTypes.forEach((type) => {
      L[type].include({
        nametag: 'geofence',
      });
    });
  }

  componentDidMount() {
    if (this.props.open) {
      setTimeout(() => {
        // this.thePopup.leafletElement._source.openPopup();
      }, 1);
    }

    this.setState({
      nametag:
        this.props.nametag || this.thePopup.leafletElement._source.nametag,
    });
  }

  parsedChildren = this.props.children.$$typeof
    ? ReactDOMServer.renderToStaticMarkup(this.props.children)
    : this.props.children;

  state = {
    editScreenOpen: false,
    inputValue: this.parsedChildren,
    content: Parser(this.parsedChildren),
    nametag: this.props.nametag,
  };

  openEditScreen = () => {
    this.props.openEditScreen();
    //   this.setState({editScreenOpen: true})
  };

  closeEditScreen = () => {
    this.setState({ editScreenOpen: false });
  };

  handleEdits = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  saveEdits = () => {
    if (this.props.saveContentCallback) {
      this.props.saveContentCallback(this.state.inputValue);
    }
    this.setState({
      content: this.state.inputValue,
    });
    this.closeEditScreen();
  };

  cancelEdits = () => {
    this.setState({
      inputValue: this.state.content,
    });
    this.closeEditScreen();
  };

  removeSource = () => {
    if (this.props.removalCallback) {
      this.props.removalCallback();
    } else {
      this.thePopup.leafletElement._source.remove();
    }
  };

  componentWillReceiveProps(nextProps)
  {
    const { refreshPolyData, refreshPolyIndex, editPolyData } = nextProps;
    const { sourceKey } = this.props;
    if(refreshPolyData === true && sourceKey === refreshPolyIndex && editPolyData !== [] && this.props.refreshPolyData !== nextProps.refreshPolyData)
    {
      const updatedContent = editPolyData.support_data;
      if(sourceKey === refreshPolyIndex)
      {
        const updatedConted = <p>
                              <p>
                                Geofence: <span> {helper.capitalizeFirstLetter(updatedContent?.title)}</span>
                              </p>
                              <p>
                                Alerts:{" "}
                                <span>
                                  {helper.capitalizeFirstLetter(updatedContent?.alert)}
                                </span>
                              </p>
                              <p>
                                Status:{" "}
                                <span>
                                  {helper.capitalizeFirstLetter(updatedContent?.status)}
                                </span>
                              </p>
                              {helper.get_user_role() === "admin" && (
                                <p>
                                  Created by: <span>{editPolyData?.created_by?.email}</span>
                                </p>
                              )}
                            </p>
        this.setState({content: updatedConted});
      }
    }
  }

  render() {
    let Buttons;

    if (this.props.removable && !this.props.editable) {
      Buttons = (
        <div className="leaflet-popup-useraction-buttons">
          <button className={`${prefix} remove`} onClick={this.removeSource}>
            Remove this {this.state.nametag}
          </button>
        </div>
      );
    } else if (!this.props.removable && this.props.editable) {
      Buttons = (
        <div className="leaflet-popup-useraction-buttons">
          <button className={`${prefix} edit`} onClick={this.openEditScreen}>
            Edit
          </button>
        </div>
      );
    } else if (this.props.removable && this.props.editable) {
      //INITALLY CALL ON GENERAL CASE
      Buttons = (
        <div className="leaflet-popup-useraction-buttons">
          <button className={`${prefix} remove`} onClick={this.removeSource}>
            Remove this {this.state.nametag}
          </button>
          <button onClick={this.openEditScreen} className={`${prefix} edit`}>
            Edit
          </button>
        </div>
      );
    }
    const contentScreen = (
      <React.Fragment>
        <Card.Header>
              <div className=" col-md-12 ml-0 mr-0 pl-0 pr-0 polyPopUp">
                  <div className="ml-0 mr-0 pl-0 pr-0 popup-poly-content">
                    {this.state.content}
                  </div>
              </div>
            </Card.Header>
        {Buttons}
      </React.Fragment>
    );

    const editScreen = (
      <React.Fragment>
        <ContentEditable
          className="leaflet-popup-input"
          html={this.state.inputValue}
          ref="editableDiv"
          onChange={this.handleEdits}
        />

        <div className="leaflet-popup-useraction-buttons">
          <button className={`${prefix} cancel`} onClick={this.cancelEdits}>
            Cancel
          </button>
          <button className={`${prefix} save`} onClick={this.saveEdits}>
            Save
          </button>
        </div>
      </React.Fragment>
    );

    return (
      <Popup
        {...this.props}
        open={this.state.open}
        ref={(thePopup) => (this.thePopup = thePopup)}
        minWidth="160"
      >
        {this.state.editScreenOpen ? editScreen : contentScreen}
      </Popup>
    );
  }
}

function mapStateToProps(state) {
  const { editPolygon, refreshPolyData, refreshPolyIndex, editPolyData } = state.drawing;
  return {
    editPolygon,
    refreshPolyData,
    refreshPolyIndex,
    editPolyData
  };
}
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditablePopup);